import AboutHero from "./components/AboutHero";
import AboutBeliefs from "./components/AboutBeliefs"
import AboutLeadership from "./components/AboutLeadership";

export default function AboutUs() {
  return (
    <>
      <AboutHero />
      <AboutBeliefs />
      <AboutLeadership />
    </>
  );
}
